import React from 'react';
import WarningIcon from '@mui/icons-material/WarningRounded';

function FormElemErrorLabel({ label = '', show = false, inputName }) {
  return (
    <label
      className={
        'transition opacity overflow-hidden ' +
        (show ? 'flex items-center o-100 error-red mb1 fs-12 fw3' : 'db o-0 h-0 w-0')
      }
      test-id={`${inputName}-error-msg`}
    >
      <WarningIcon fontSize="inherit" />
      <span className="flex items-center ml1">{label}</span>
    </label>
  );
}

export default FormElemErrorLabel;
